// extracted by css-extract-rspack-plugin
export default {"input":"input-T1Fl_U"};